@if (branchDistributionList.length > 0) {
  <table class="table">
    <thead>
      <tr>
        <th>Branch</th>
        <th>Distribution</th>
      </tr>
    </thead>

    <tbody>
      @for (d of branchDistributionList; track d; let i = $index) {
        <tr>
          <td>
            @if (d.appliedBranch.ID != companyId) {
              <button
                type="button"
                class="btn btn-danger me-2"
                (click)="removeBranch(i)"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            }
            {{ d.appliedBranch.CompanyCode }}
          </td>
          <td>
            <div class="form-floating">
              <input
                type="number"
                class="form-control"
                [id]="'distributedAmount-' + i"
                [name]="'distributedAmount-' + i"
                placeholder="Branch Amount"
                [(ngModel)]="d.amount"
                (keypress)="sharedService.isNumberKey($event)"
                required
              />
              <label for="distributedAmount">Branch Amount</label>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (allowAdding) {
  <app-search-company-by-uid
    (passEntry)="getSelectedCompany($event)"
  ></app-search-company-by-uid>
}


